import React, { useState } from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseIcon from "@mui/icons-material/Close";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffffff",
    color: "#333",
    boxShadow: theme.shadows[7],
    fontSize: 14,
    maxWidth: 220,
    padding: "10px",
    borderRadius: "8px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#ffffff",
  },
}));

const InfoTooltip = ({ textToDisplay }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const [open, setOpen] = useState(false);

  const handleOpenDrawer = () => setOpen(true);
  const handleCloseDrawer = () => setOpen(false);

  return (
    <>
      {isMobile ? (
        <>
          <IconButton size="small" sx={{ padding: 0, color: "#343d4c" }} onClick={handleOpenDrawer}>
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>

          <SwipeableDrawer
            anchor="bottom"
            open={open}
            onClose={handleCloseDrawer}
            onOpen={() => {}}
            slotProps={{
              paper: {
                sx: {
                  borderTopLeftRadius: 16,
                  borderTopRightRadius: 16,
                  padding: 3,
                  minHeight: "100px",
                  backgroundColor: "#fff",
                },
              },
            }}
          >
            <Box sx={{ position: "relative" }}>
              <IconButton
                onClick={handleCloseDrawer}
                sx={{
                  position: "absolute",
                  top: 0,
                  right: 8,
                  backgroundColor: "#f1f1f1",
                  marginBottom: 2,
                  width: 32,
                  height: 32,
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>

              <Box sx={{ paddingTop: 4 }}>
                <span 
                  dangerouslySetInnerHTML={{
                    __html: textToDisplay,
                  }}
                />
              </Box>
            </Box>
          </SwipeableDrawer>
        </>
      ) : (
        <LightTooltip
          title={
            <Box>
              <span 
                dangerouslySetInnerHTML={{
                  __html: textToDisplay,
                }}
              />
            </Box>
          }
          arrow
        >
          <IconButton size="small" sx={{ padding: 0, color: "#343d4c" }}>
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        </LightTooltip>
      )}
    </>
  );
};

export default InfoTooltip;
